/* Bayou Beignet product-page reveals. The page remains complete without
   JavaScript; this only adds a one-time, reduced-motion-safe entrance. */
(function () {
  if (!document.querySelector('.bb-pdp')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches || !('IntersectionObserver' in window)) return;

  var targets = document.querySelectorAll(
    '.bb-steps .bb-step, .bb-rev-summary .bb-rev-summary__rating, .bb-rev-summary .bb-rev-summary__photo, .bb-bundle .bb-bundle-card'
  );

  if (!targets.length) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  Array.prototype.forEach.call(targets, function (target, index) {
    target.classList.add('bb-pdp-reveal-target');
    target.style.setProperty('--bb-pdp-delay', ((index % 4) * 55) + 'ms');
    observer.observe(target);
  });
})();
